module.exports = __webpack_public_path__ + "static/media/BuenosAiresWeb-ThinItalic.3b082db8.woff";